"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeystoneEthereumKeyring = exports.KeystoneEthereumKeyring = exports.KeystoneEthereumInteractionProvider = void 0;
const bc_ur_registry_eth_1 = require("@keystonehq/bc-ur-registry-eth");
const base_eth_keyring_1 = require("@keystonehq/base-eth-keyring");
const bc_ur_registry_1 = require("@keystonehq/bc-ur-registry");
const secp256k1_1 = require("secp256k1");
const transactions_1 = require("@ethersproject/transactions");
class KeystoneEthereumInteractionProvider {
    constructor() {
        this.readUR = () => __awaiter(this, void 0, void 0, function* () {
            throw new Error("KeystoneError#readUR function is not set.");
        });
        this.playUR = () => __awaiter(this, void 0, void 0, function* () {
            throw new Error("KeystoneError#playUR function is not set.");
        });
        this.readCryptoHDKeyOrCryptoAccount = () => __awaiter(this, void 0, void 0, function* () {
            const result = yield this.readUR();
            if (result.type === "crypto-hdkey") {
                return bc_ur_registry_1.CryptoHDKey.fromCBOR(Buffer.from(result.cbor, "hex"));
            }
            else {
                return bc_ur_registry_1.CryptoAccount.fromCBOR(Buffer.from(result.cbor, "hex"));
            }
        });
        this.requestSignature = (ethSignRequest, requestTitle, requestDescription) => __awaiter(this, void 0, void 0, function* () {
            const ur = ethSignRequest.toUR();
            yield this.playUR({
                type: ur.type,
                cbor: ur.cbor.toString("hex"),
            }, {
                title: requestTitle,
                description: requestDescription,
            });
            const result = yield this.readUR();
            return bc_ur_registry_eth_1.ETHSignature.fromCBOR(Buffer.from(result.cbor, "hex"));
        });
    }
    onReadUR(readUR) {
        this.readUR = readUR;
    }
    onPlayUR(playUR) {
        this.playUR = playUR;
    }
}
exports.KeystoneEthereumInteractionProvider = KeystoneEthereumInteractionProvider;
class KeystoneEthereumKeyring extends base_eth_keyring_1.BaseKeyring {
    constructor() {
        super();
        this.getInteraction = () => {
            return this.interaction;
        };
        this.interaction = new KeystoneEthereumInteractionProvider();
    }
    static getEmptyKeyring() {
        return new KeystoneEthereumKeyring();
    }
    syncKeyringData(data) {
        const key = data.keys.find((e) => e.coinType === 60);
        this.xfp = data.xfp;
        if (key) {
            const pubKeyBuf = Buffer.from(secp256k1_1.publicKeyConvert(Buffer.from(key.pubKey, "hex"), true));
            this.hdPath = `m/44'/${key.coinType}'/${key.bip44HDPath.account}'`;
            this.indexes[transactions_1.computeAddress(pubKeyBuf)] = key.bip44HDPath.addressIndex;
        }
    }
    checkKeyring() {
        if (!this.xfp || !this.hdPath) {
            throw new Error("KeystoneError#invalid_keyring: keyring not fulfilled, please call function `readKeyring` firstly");
        }
    }
}
exports.KeystoneEthereumKeyring = KeystoneEthereumKeyring;
KeystoneEthereumKeyring.type = base_eth_keyring_1.BaseKeyring.type;
function useKeystoneEthereumKeyring({ readUR, playUR, keyringData, }) {
    const keyring = KeystoneEthereumKeyring.getEmptyKeyring();
    if (keyringData) {
        keyring.syncKeyringData(keyringData);
    }
    if (readUR) {
        keyring.getInteraction().onReadUR(readUR);
    }
    if (playUR) {
        keyring.getInteraction().onPlayUR(playUR);
    }
    return keyring;
}
exports.useKeystoneEthereumKeyring = useKeystoneEthereumKeyring;
//# sourceMappingURL=ethereum-keyring.js.map